export default __webpack_public_path__ + "static/media/steveaoki.071cef8e.png";